import { Navigate as NavigateR, useLocation } from 'react-router-dom';

const Navigate = (props) => {
  const { state } = useLocation();

  return <NavigateR state={state} {...props} />;
};

export default Navigate;
